import { getPathVersion } from '@repo/common-utils/utils/env'
import { FSHttp } from '@fs/http'
import initInterceptors from './interceptors'
import { ENCRYPT_TYPES as et } from './contansts'
import { createUUID as _createUUID } from '@fs/utils'
import h5Http from './h5Http'
import { JSBridge } from '@fs/jsbridge'

const { VUE_APP_ENV } = import.meta.env

const http = FSHttp()

http?.registerDecryptFunction({ VUE_APP_ENV: VUE_APP_ENV })

initInterceptors(http)

export const get = (url, paramet = {}) => {
  const baseParams = { jsBridge: true, encrypt: ENCRYPT_TYPES.LOGIN }

  const encrypt = transformIsTradeAndEncTagToEncrypt(paramet)
  if (typeof encrypt === 'number') {
    paramet.encrypt = encrypt
  }

  const params = {
    url,
    method: 'get',
    ...Object.assign({}, baseParams, paramet),
  }
  if (paramet?.jsBridge === false) {
    return h5Http.request(params)
  }
  return http.request(params)
}

export const post = (url, paramet = {}) => {
  const postConfig = {
    jsonRpc: true, // post 默认开启 jsonRpc 2.0
    // 默认在APP中加密； 1 临时加密； 2 登录加密  其他情况强制不加密
    encrypt: ENCRYPT_TYPES.LOGIN,
    jsBridge: true,
  }
  const encrypt = transformIsTradeAndEncTagToEncrypt(paramet)
  if (typeof encrypt === 'number') {
    paramet.encrypt = encrypt
  }
  const params = { url, method: 'post', ...Object.assign({}, postConfig, paramet) }
  if (paramet?.jsBridge === false) {
    return h5Http.request(params)
  }
  return http.request(params)
}

/**
 * 将内部的isTrade、noEncTag、encTag、encrypt等参数统一为encrypt
 * @param {*} config 用户配置
 * @returns 加解密类型 0 不加密 1 临时加密 2 登录加密 3 交易加密 4 强制交易加密
 */
function transformIsTradeAndEncTagToEncrypt(config = {}) {
  let encrypt

  const encTagToEncMap = {
    'trade/enc': ENCRYPT_TYPES.TRADE,
    'user/enc': ENCRYPT_TYPES.LOGIN,
    'tradeverify/enc': ENCRYPT_TYPES.FORCE_TRADE,
  }
  if (config.isTrade) {
    encrypt = ENCRYPT_TYPES.TRADE
  }
  // 接口层会通过jsbridge参数来强制走H5请求，因此当前情况直接返回
  if (config.jsBridge === false) {
    return encrypt
  }
  if (JSBridge) {
    if (!config.noEncTag && localStorage.getItem('rndKey')) {
      // 增加encTag、isTrade、noEncTag参数的判断，默认为登录加密
      if (config.encTag) {
        encrypt = encTagToEncMap[config.encTag] || encrypt
      } else if (config.isTrade) {
        encrypt = ENCRYPT_TYPES.TRADE
      } else {
        encrypt = ENCRYPT_TYPES.LOGIN
      }
    }
    if (config.noEncTag === true) {
      encrypt = ENCRYPT_TYPES.NO_ENCRYPT
    }
  }
  return encrypt
}

// APP 内使用 v1, 否则使用 v0
export const path_version = getPathVersion()

export default {
  get,
  post,
  path_version,
}

//创建 uuid
export const createUUID = _createUUID

// 加密类型
export const ENCRYPT_TYPES = et
